export default __webpack_public_path__ + "static/media/hard_skill_code.64c2f85d.svg";